<template>
  <template v-if="isLogin">
    <slot></slot>
  </template>
</template>

<script lang="ts">
import { defineComponent, computed, watch } from 'vue'
import { useStore, Store } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { generateRedirectLinkQuery } from '@/services/route'

/**
 * 申請基本ログイン
 * Storeのログイン状態をチェックし、未ログインならログインページに遷移させる
 */
export default defineComponent({
  name: 'RequestHeaderLoginWrapper',
  setup() {
    const store = useStore() as Store
    const route = useRoute()

    const isLogin = computed(() => {
      return store.getters['requestHeader/isLogin']
    })

    watch(
      isLogin,
      () => {
        if (!isLogin.value) {
          // 未ログイン時はログインページに飛ばす
          const errPath = route.meta.loginPath
          if (errPath == null) {
            // エラーページ未設定の場合はエラー
            throw new Error('undefined login path')
          }
          // ログインページに戻り先URL付きで飛ばす
          const router = useRouter()
          router.push({
            path: errPath,
            query: generateRedirectLinkQuery(route.path),
          })
        }
      },
      { immediate: true }
    )

    return { isLogin }
  },
})
</script>
